import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { BrowserRouter } from 'react-router-dom';

ReactDOM.createRoot(document.getElementById('root')!).render(
  //<React> {// Enable only when testing without three.js}
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  //{</React>}
);
